import {Table} from 'flowbite-react';
import {SearchInput} from '../SearchInput';
import * as React from 'react';
import {ItemInput} from '../../../@types';
import {TableColumn} from './index';
import {useInventorySearch} from '../../../hooks';
import {useEffect} from "react";
import { CloseIcon, RemoveIcon } from '../../../assets/icons';

export interface Props {
  item: ItemInput;
  columns: TableColumn[];
  index: number;
  isSearchInput: boolean;
  removeItem: (index: number) => void;
  updateError: (index: number, error: string[]) => void;
  updateCell: (rowIndex: number, columnId: string, value: string | number) => void;
  updateRow: (rowIndex: number, updatedRow: ItemInput) => void
  errors: string[];
}
export interface LineItemRef {
  validate: () => boolean;
}

const LineItem: React.ForwardRefRenderFunction<LineItemRef, Props> = (
  { isSearchInput, columns, index,removeItem, updateRow, updateCell, item, errors, updateError },
  ref,
) => {
  const handleUpdate = (field: keyof ItemInput, value: string | number) => {
    updateCell(index, field as string, value);
    if (errors && errors.includes(field as string)) {
      errors = errors.filter((err) => err !== field);
      updateError(index, errors);
    }
  };
  const {
    data: inventories,
    isSearching: isInventorySearching,
    handleSearch: handleInventorySearch,
  } = useInventorySearch();
  const [showNewInventoryModal, setShowNewInventoryModal] = React.useState<boolean>(false);
  const handleInventorySearchDebounced = React.useCallback(handleInventorySearch, []);
  const handleItemSelect = React.useCallback((itemData: ItemInput | null) => {
    if (itemData) {
      updateRow(index, { ...itemData, quantity: 1, rate: itemData.rate as number });
    } else {
      updateRow(index, { id: '', name: '', quantity: 0, rate: 0 });
    }
  }, [index, updateRow]);
  useEffect(() => {
  }, [item])

  return (
    <>
      <Table.Row key={index} className="bg-white  ">
        {columns.map(({ label }, columnIndex) => (
          <Table.Cell
            key={columnIndex}
            className={`
          ${columnIndex === 0 ? ' pr-[20px] border-r' : ' border-r '}
          ${columnIndex === 0 ? 'w-[100px]' : 'w-[150px] md:w-[150px]'} `}
        
          >
            {columnIndex === 0 ? (
              isSearchInput ? (
                <div className=''>
                  <SearchInput
                    placeholder="Enter Item Name"
                    data={inventories}
                    displayKey="name"
                    isLoading={isInventorySearching}
                     emptyMessage={'No Items yet'}
                    classNames="border-none shadow-inner placeholder:text-[#A4A4A4] placeholder:text-[13.25px] border-none bg-gray-100 shadow-md rounded-lg placeholder:text-[#A4A4A4] md:w-[160px] lg:w-[140px] biglg:w-[200px] xl:w-[280px] 2xl:w-[300px] 3xl:w-[350px] bigmd:w-[160px] 4xl:w-[400px] "
                    value={item?.id}
                    selected={item.id ? item : null }
                    clearIcon={CloseIcon}
                    clearIconClass="xl:mr-[2em] md:mr-[1.7em] lg:mr-[2.5em] biglg:mr-[2em] bigmd:mr-[4.3em] 2xl:mr-[4em]  3xl:mr-[7em] xl:mt-[0.9em]"
                    handleChangeText={handleInventorySearchDebounced}
                    onSelect={handleItemSelect}
                    dropdownClassName="xl:w-[280px] lg:w-[140px] 2xl:w-[300px]  md:w-[160px]  biglg:w-[200px] bigmd:w-[160px] 3xl:w-[350px] 4xl:w-[400px]"
                    dropdownStyle={{
                      maxHeight: '800px',
                      overflowY: 'auto',
                    }}
                 
                  />
                  {errors.includes('name') && (
                    <p className="text-red-500 text-xs mt-1">Please select a valid item</p>
                  )}
                </div>
              ) : (
                <div>
                  <input
                    type="text"
                    className={`border-none shadow-inner placeholder:text-[#A4A4A4] placeholder:text-[13.25px] border-none bg-gray-100 shadow-md rounded-lg placeholder:text-[#A4A4A4] md:w-[160px] lg:w-[140px] biglg:w-[200px] xl:w-[280px] 2xl:w-[300px] 3xl:w-[350px] bigmd:w-[160px] 4xl:w-[400px] "] ${
                      errors.includes('name') ? 'border-red-500' : ''
                    } ${item?.name ? 'focus:outline-none focus:border-[#138EFF] focus:ring-2 focus:ring-[#138EFF]' : ''}`}
                    placeholder="Enter Item Name"
                    value={item?.name}
                    onChange={({ target }) => handleUpdate('name', target.value)}
                  />
                  {errors.includes('name') && (
                    <p className="text-red-500 text-xs mt-1">Please enter a value</p>
                  )}
                </div>
              )
            ) : columnIndex === columns.length - 2 ? (
              <input
                type="text"
                className=' md:w-[110px] bigmd:w-[110px] lg:w-[100px] biglg:w-[200px] 2xl:w-[220px] 3xl:w-[250px] 4xl:w-[300px] xl:w-[190px] border-none bg-gray-100 shadow-md rounded-lg placeholder:text-[#A4A4A4]'
                readOnly
                placeholder="Amount"
                value={
                  !isNaN(Number(item?.quantity)) && !isNaN(Number(item?.rate))
                    ? (Number(item?.quantity) * Number(item?.rate)).toFixed(2) 
                    : ''
                }
              />
            ) : columnIndex === columns.length - 1 ? (
              <button type="button" onClick={() => removeItem(index)}>
                <RemoveIcon/> <span className="text-xl text-red"></span>
              </button>
            ): (
              <input
                type="number"
                min="0"
                step="0.01"
                className={`border-none bg-gray-100 shadow-md rounded-lg placeholder:text-[#A4A4A4] 3xl:w-[250px] 4xl:w-[300px] md:w-[110px]  bigmd:w-[110px] lg:w-[120px] biglg:w-[150px] xl:w-[190px] 2xl:w-[220px] bigmd:w-[120px]${
                  errors.includes(label.toLowerCase()) ? 'border-red-500' : ''
                }`}
                placeholder={columnIndex === 1 ? 'Enter Item Quantity' : 'Enter Item Rate'}
                value={
                  (Number(item?.[label.toLowerCase()]))
                    ? Number(item?.[label.toLowerCase()] as number)
                    : ''
                }
                onChange={({ target }) => handleUpdate(label.toLowerCase() as keyof ItemInput, target.value)}
              />
            )}
            {errors.includes(label.toLowerCase()) && (
              <p className="text-red-500 text-xs mt-1">Please enter a value</p>
            )}
          </Table.Cell>
        ))}
      </Table.Row>
    </>
  );
};
export default React.forwardRef(LineItem);
